export const queueManagerPath = () => '/settings/queue-manager';
